import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { apiService } from '@/services/apiService'
import { usePermissionsStore } from '@/stores/permissionsStore'
import { useAuth } from './use-auth'

/** Call once at app root (AppContent). Fetches and populates the permissions store. */
export function usePermissionsLoader(): void {
  const { isAuthenticated } = useAuth()
  const { setActions } = usePermissionsStore()

  const { data } = useQuery({
    queryKey: ['user-permissions'],
    queryFn: () => apiService.permissions.getPermissions(),
    enabled: isAuthenticated,
    staleTime: 5 * 60 * 1000,
    retry: false,
  })

  useEffect(() => {
    if (!data) return
    if (data.success && data.data) {
      setActions(data.data.permissions)
    }
  }, [data, setActions])
}

/** Use anywhere to check a permission. Returns true while loading (optimistic). */
export function usePermissions() {
  const { actions, fullAccess } = usePermissionsStore()

  return {
    can(action: string): boolean {
      if (actions === null || fullAccess) return true
      return actions.includes(action)
    },
  }
}
